// HOOKS
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {
  hotelNameSelector,
  roomsDataSelector,
  searchRoomApiRequestSelector,
  similarPropertiesSelector,
  similarPropertiesRankingAlgoSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {
  hotelsPartnerFn,
  checkinSelectorFn,
  checkoutSelectorFn,
  roomStringSelectorFn,
  countrySelectorFn,
  metaPartnerSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';

import SimilarHotelsUI from '../../../../stories/components/hotels/DetailsPageUnif/SimilarHotelsUI/SimilarHotelsUI';
// import SimilarHotelsLoader from '../../../../stories/components/hotels/Loadingpage/SimilarHotelsLoader/SimilarHotelsLoader';

const SimilarHotels = () => {
  const hotelName = useSelector(hotelNameSelector);
  const roomsDataFromCg = useSelector(roomsDataSelector);
  const searchRoomApiRequest = useSelector(searchRoomApiRequestSelector);

  const isSoldOut =
    searchRoomApiRequest?.success && (!roomsDataFromCg || roomsDataFromCg?.length == 0);
  const hotelList = useSelector(similarPropertiesSelector);
  const hotelPartner = useSelector(hotelsPartnerFn);
  const checkinJSDate = useSelector(checkinSelectorFn).date;
  const checkoutJSDate = useSelector(checkoutSelectorFn).date;
  const roomString = useSelector(roomStringSelectorFn);
  const countryCode = useSelector(countrySelectorFn);
  const metaPartner = useSelector(metaPartnerSelectorFn);
  const similarPropertiesRankingAlgo = useSelector(similarPropertiesRankingAlgoSelector);
  const {cityName = ''} = useParams<{cityName: string}>();

  // no similar hotels came from data
  if (!(hotelList.length && hotelList.length > 1)) {
    return null;
  }

  const currentHotel = hotelList[0];
  const similarHotels = hotelList.slice(1);
  const heading = hotelName ? `Similar Properties to ${hotelName}` : 'Similar Hotels';

  return (
    <SimilarHotelsUI
      similarHotels={similarHotels}
      currentHotel={currentHotel}
      isSoldOut={isSoldOut} //TODO: UNIF
      heading={heading}
      hotelPartner={hotelPartner}
      checkinJSDate={checkinJSDate}
      checkoutJSDate={checkoutJSDate}
      roomString={roomString}
      countryCode={countryCode}
      metaPartner={metaPartner}
      cityName={cityName}
      similarPropertiesRankingAlgo={similarPropertiesRankingAlgo}
    />
  );
};

export default SimilarHotels;
